import type { PersonAPI } from '~/services/person-api/person-api.types';
import type { RegisterAPI } from '~/services/register-api/register-api.types';

import type { PartnerDocRow } from '../types';

interface BuildPartnerDocumentsInput {
  operatingAgreement?: null | Pick<PersonAPI.GetSignedOperatingAgreementResponse, 'url' | 'url_inline'>;
  operationTermAccepted?: boolean;
  socialContract?: null | RegisterAPI.PartnerDocument;
}

/**
 * Monta as linhas da lista de documentos do parceiro (seção "Informações Adicionais").
 * - Acordo Operacional: só quando o termo foi aceito e há URL utilizável (person-api).
 * - Contrato Social: só quando existe e há URL utilizável (register-api).
 */
export default function buildPartnerDocuments(input: BuildPartnerDocumentsInput): PartnerDocRow[] {
  const { operatingAgreement, operationTermAccepted, socialContract } = input;
  const rows: PartnerDocRow[] = [];

  if (operationTermAccepted && hasUsableUrl(operatingAgreement)) {
    rows.push({
      key: 'operational-agreement',
      label: 'Acordo Operacional',
      url: operatingAgreement?.url ?? null,
      url_inline: operatingAgreement?.url_inline ?? null,
    });
  }

  if (hasUsableUrl(socialContract)) {
    rows.push({
      filename: socialContract?.filename,
      key: 'social-contract',
      label: 'Contrato Social',
      url: socialContract?.url ?? null,
      url_inline: socialContract?.url_inline ?? null,
    });
  }

  return rows;
}

function hasUsableUrl(doc?: null | { url?: null | string; url_inline?: null | string }): boolean {
  return !!doc && (!!doc.url_inline || !!doc.url);
}
